import React from 'react';

const PinMarker = (props) => {
	return (
		<div className="map-pin-marker-generic"></div>
	);
};

export default PinMarker;
